import { render, staticRenderFns } from "./CategoryCollectionProducts.vue?vue&type=template&id=7d52393c&"
import script from "./CategoryCollectionProducts.vue?vue&type=script&lang=ts&"
export * from "./CategoryCollectionProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports